import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';

var submit = function submit(opt) {
  var iActivityId = opt.iActivityId,
      iFlowId = opt.iFlowId;
  return ams.amsInit(iActivityId, iFlowId, opt).then(function (_ref) {
    var config = _ref.config;

    if (!config.sData) {
      config.sData = {};
    }

    return FlowEngine.submit(config);
  });
};

export default {
  submit: submit
};